module.exports = __webpack_public_path__ + "media/images/v2/icon5-a86fbda06e6978db927f97542d83d406.png";